import { Field } from 'react-final-form';
import { t } from 'ttag';
import classNames from 'classnames';

import {
  composeValidators,
  required,
  validateForbiddenEmail,
  validateIsEmail,
  validateTooShort,
} from '@utils/validators';
import { Input } from '@ui/Input';
import { TextArea } from '@ui/TextArea';
import { Button } from '@ui/Button';

// styles
import s from './SubmitComplaint.sss';

// types
type SubmitComplaintProps = {
  handleSubmit: () => void;
  closeModal: () => void;
  submitting: boolean;
  pristine: boolean;
  isMobile?: boolean;
  error: boolean;
  initialEmail: string | null | undefined
};

export const SubmitComplaint: React.FC<SubmitComplaintProps> = ({
  handleSubmit,
  closeModal,
  submitting,
  pristine,
  isMobile,
  error,
  initialEmail,
}) => (
  <form onSubmit={handleSubmit}>
    <div>
      <label className={s.emailLabel}>E-mail</label>
      <Field<string>
        name="email"
        initialValue={initialEmail || undefined}
        validate={composeValidators(validateForbiddenEmail, validateIsEmail, required)}
      >
        {({ input, meta }) => (
          <div>
            <Input {...input} placeholder="E-mail" className={s.input} />
            {(meta.error || meta.submitError) && (meta.touched || initialEmail)
              ? <p className={s.error}>{meta.error || meta.submitError}</p>
              : <p className={s.emailTip}>{t`Обов'язково до заповнення`}</p>}
          </div>
        )}
      </Field>
      <div className={s.warning}>
        <p className={s.warningText}>
          {t`Не додавайте email на mail.ru, mail.ua, yandex.ru, yandex.ua, list.ru, inbox.ru, bk.ru, vk.ru, ok.ru`}
        </p>
      </div>
    </div>
    <div>
      <label className={s.commentLabel}>{t`Коментарі`}</label>
      <Field<string>
        name="text"
        validate={composeValidators(validateTooShort(20), required)}
      >
        {({ input, meta }) => (
          <div>
            <TextArea
              {...input}
              autoFocus={true}
              minLength={20}
              maxLength={1000}
              className={classNames(s.input, s.textarea)}
            />
            {
                  (meta.error || meta.submitError)
                  && meta.touched
                    ? <p className={s.error}>{meta.error || meta.submitError}</p>
                    : <p className={s.commentTip}>{t`Обов'язково до заповнення`}</p>
                }
          </div>
        )}
      </Field>
    </div>
    <div className={s.buttonGroup}>
      <Button
        theme="secondary"
        className={isMobile ? s.mobileButton : s.buttonLeft}
        onClick={closeModal}
      >
        {t`Відміна`}
      </Button>
      <Button
        type="submit"
        disabled={submitting || pristine || error}
        className={isMobile ? s.mobileButton : s.buttonRight}
      >
        {t`Надіслати`}
      </Button>
    </div>
  </form>
);

export default SubmitComplaint;
